import { EVENT_MESSAGES } from './utils';

class FormBridgeClient {
  _isReady: boolean;
  _uid: string;

  constructor(options?: { key?: string }) {
    this._isReady = false;
    this._uid = options?.key || '';
  }

  // client 加载完成回调
  onReady(callback?: any) {
    window.parent.postMessage(
      {
        msg: EVENT_MESSAGES.CLIENT_READY,
        uid: this._uid,
      },
      '*',
    );
    callback && callback();
    console.log('[client]: client is ready...');
    this._isReady = true;
  }

  // 关闭 iframe
  close() {
    window.parent.postMessage(
      {
        msg: EVENT_MESSAGES.CLOSE_DIALOG,
        uid: this._uid,
      },
      '*',
    );
  }

  // client 接收数据，这时候是不需要判断 uid的，因为发送信息指定的是这个 contentWindow
  onReceiveData(callback?: any) {
    function func({ data }) {
      console.log('[client]: 收到 master 的数据', data);
      if (data && data.uid) {
        this._uid = data.uid;
      }
      callback && callback(data);
    }

    window.addEventListener(
      'message',
      func.bind(this),
      { capture: false, once: true },
    );
  }

  /**
   * 提交数据，这时候需要判断 uid ，因为父级window下可能有多个 iframe，需要标明是哪个content发送的消息
   */
  postData(data?: any) {
    console.log('[client]: 向 master 发送数据');
    window.parent.postMessage(
      {
        msg: EVENT_MESSAGES.CLIENT_POST_DATA,
        uid: this._uid,
        data,
      },
      '*',
    );
  }
}

export default FormBridgeClient;
